const defaultState = {
	appPage: 'Requests',
	appMode: ''
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case 'APPBAR_SET_PAGE': {      
			return {
				...state,
				appPage: action.payload == 'Administrator' ? 'AdministratorRegisteredPhones' : action.payload,
				appMode: action.payload.startsWith('Administrator') ? 'Administrator' : ''
			}
		}
		default:
			return state;
	}
}